import React from "react";
import { CoRetrieveDocumentData } from "../../components/generic/CoRetrieveDocumentData";
import { DocumentNotValidError } from "../../components/generic/DocumentNotValidError";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { OperationCompletedPanel } from "../../components/layout/OperationCompletedPanel";

export const SynchRestorePage: React.FunctionComponent = () => {
  return (
    <ProtectedComponent userFunction={UserFunctionEnum.MENU_SYNCHRONIZE} errorComponent={<UnauthorizedError />}>
      <CoRetrieveDocumentData>
        {({ coObject }) =>
          coObject?.documentId ? (
            <OperationCompletedPanel
              title={formatMessage("cof.synch.info")}
              message={formatMessage("cof.sync.deprecated")}
              alt={formatMessage("cof.sync.deprecated")}
              icon="/assets/warning.png"
              styles={{ container: { minHeight: "70vh" } }}
            />
          ) : (
            <DocumentNotValidError />
          )
        }
      </CoRetrieveDocumentData>
    </ProtectedComponent>
  );
};
